module.exports = __webpack_public_path__ + "static/img/contant_1.9c0732e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_6/contant_1.jpeg
// module id = 8ZUl
// module chunks = 0